/* eslint-disable camelcase */
import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import menuService from 'live/services/menu'
import Router from 'live/services/router'

import { en_us, pt_br } from './i18n'
import { SystemAuditWrapper } from './SystemAudit/SystemAuditWrapper'
import { AUDIT_AREA, AUDIT_PATH, AUDIT_URL } from './utils/constants'

const localeFiles = { pt_br, en_us }

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}

menuService.register(
    {
        alias: AUDIT_AREA,
        selectedAliases: [AUDIT_AREA],
        name: i18n('Audit'),
        order: 99,
        url: AUDIT_URL,

        config: { showOnMobile: false }
    },
    'regular'
)

Router.route(
    AUDIT_PATH,
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    (SystemAuditWrapper as unknown) as React.Component<{}, {}, any>,
    AUDIT_AREA,
    { hideFooter: true, hideHeader: false }
)
